import c from "classnames";
import { useNavigate } from "react-router";

import { DashboardWidget } from "@components/Dashboards/shell";

import { Button } from "@design-system/Button/Button";
import { Skeleton } from "@design-system/Skeleton/Skeleton";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

import { useApplicationReviewStateMixQuery } from "./ApplicationReviewStateMixCard.g";
import classes from "./ApplicationReviewStateMixCard.module.css";

type Props = {
  clientId: string;
};

const STATES: {
  key: "discovered" | "evaluating" | "approved" | "unapproved";
  label: string;
  alert?: boolean;
}[] = [
  { key: "discovered", label: "Discovered" },
  { key: "evaluating", label: "Evaluating" },
  { key: "approved", label: "Approved" },
  { key: "unapproved", label: "Unapproved", alert: true },
];

export const ApplicationReviewStateMixCard = ({ clientId }: Props) => {
  const navigate = useNavigate();
  const { data, isLoading } = useApplicationReviewStateMixQuery({ clientId });
  const mix = data?.applicationReviewStateMix;
  const totalCount = mix?.totalCount ?? 0;

  return (
    <DashboardWidget
      title="Review progress"
      definition={
        isLoading
          ? undefined
          : `${totalCount} application${totalCount === 1 ? "" : "s"} in inventory`
      }
      actions={
        <Button
          variant="outlined"
          color="secondary"
          size="sm"
          onClick={() => {
            navigate(
              routes.portal.clients.client.applications.$buildPath({
                params: { clientId },
              }),
              { viewTransition: true },
            );
          }}
        >
          Review applications
        </Button>
      }
    >
      <div className={classes.figures}>
        {STATES.map(({ key, label, alert }) => (
          <div key={key} className={classes.figure}>
            {isLoading ? (
              <Skeleton width={32} height={21} />
            ) : (
              <span className={c(classes.value, alert && classes.alert)}>
                {mix?.[key] ?? 0}
              </span>
            )}
            <Text size={12} color="textSecondary">
              {label}
            </Text>
          </div>
        ))}
      </div>
    </DashboardWidget>
  );
};
